export const SCROLL = 'scroll';
export const SCROLL_UPDATE = 'ScrollManager:update';
export const SCROLL_TOGGLE = 'ScrollManager:toggle';
export const RESIZE = 'resize';
export const RESIZE_UPDATE = 'ResizeManager:update';
export const MENU_TOGGLE = 'menu:toggle';
export const LOAD = 'load';
export const DOM_CONTENT_LOADED = 'DOMContentLoaded';
